import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { APP_NAME } from "@/config/constants";
import { Footer } from "@/components/ui/footer";
import { HomeNavbar } from "@/components/home/HomeNavbar/HomeNavbar";
import { Container } from "@/components/ui/container";
import { PATHS } from "@/config/paths";

export const Route = createFileRoute("/_home")({
  component: HomeLayout,
});

function HomeLayout() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: APP_NAME,
    description:
      "AI-powered personal growth platform that helps you transform your health goals into daily progress",
    applicationCategory: "Productivity",
    operatingSystem: "Web, iOS",
    offers: {
      "@type": "Offer",
      price: "9.99",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
    },
    featureList: [
      "AI-powered goal planning",
      "Daily progress tracking",
      "Routine building",
      "Personalized insights",
      "Cross-platform accessibility",
    ],
    keywords: [
      "goal tracking",
      "AI coach",
      "self improvement",
      "habit tracker",
      "personal growth",
      "mindfulness",
      "motivation",
    ],
  };

  const pathname = useRouterState({ select: (state) => state.location.pathname });

  // Define routes where TabBar should be visible
  const tabBarRoutes = [
    PATHS.LOGIN,
    PATHS.REGISTER,
    PATHS.FORGOT_PASSWORD,
    PATHS.RESET_PASSWORD,
  ] as const;

  // Check if current route should show the TabBar
  const dontShowFooter = tabBarRoutes.includes(pathname as (typeof tabBarRoutes)[number]);

  return (
    <div className="min-h-screen flex flex-col">
      <script
        id="structured-data"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <HomeNavbar />
      <main className="flex-1 space-y-20 md:space-y-[100px] mt-[100px] mb-10">
        <Container className="space-y-10">
          <Outlet />
        </Container>
      </main>

      {!dontShowFooter && <Footer />}
    </div>
  );
}
